/* eslint-disable class-methods-use-this */
import Cookies from 'js-cookie';

export default class CookieNotice {
  constructor(app) {
    this.app = app;
    this.cookieNotice = document.querySelector('.js-cookie-notice');
    this.allLinks = document.querySelectorAll('.js-cookie-notice a');
    this.consentLink = document.querySelector('.js-cookie-consent');

    this.cookieName = 'sma';
    this.cookies = [
      {
        name: 'strictly_necessary',
        value: true,
      },
      {
        name: 'functional',
        value: true,
      },
      {
        name: 'analytics',
        value: true,
      },
      {
        name: 'third_party',
        value: true,
      },
    ];

    this.consentLinkClick = this.consentLinkClick.bind(this);
    this.showCookieNotice = this.showCookieNotice.bind(this);
    this.hideCookieNotice = this.hideCookieNotice.bind(this);
    this.setCookies = this.setCookies.bind(this);

    this.init();
  }

  init() {
    if (this.cookieNotice) {
      if (Cookies.get(`${this.cookieName}`)) return;
      setTimeout(this.showCookieNotice, 1500);
    }

    this.events();
  }

  events() {
    this.allLinks.forEach((link) => {
      link.addEventListener('click', this.hideCookieNotice);
    });
    if (!this.consentLink) return;
    this.consentLink.addEventListener('click', this.consentLinkClick);
  }

  consentLinkClick() {
    this.setCookies();
    this.hideCookieNotice();
  }

  destroy() {
    if (this.cookieNotice) this.cookieNotice = null;
    if (this.allLinks) {
      this.allLinks.forEach((link) => {
        link.removeEventListener('click', this.hideCookieNotice);
      });
      this.allLinks = null;
    }
    if (this.consentLink) this.consentLink.removeEventListener('click', this.consentLinkClick);
  }

  hideCookieNotice() {
    this.cookieNotice.classList.remove('--visible');
  }

  showCookieNotice() {
    this.cookieNotice.classList.add('--visible');
  }

  setCookies() {
    Cookies.set(`${this.cookieName}`, true, {
      expires: 365,
      secure: false,
    });

    this.cookies.forEach((cookie) => {
      Cookies.set(`${this.cookieName}-${cookie.name}`, cookie.value, {
        expires: 365,
        secure: false,
      });
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/cookieNotice.js